<div class="container container--mobile-padding">
	<grid-people [peopleData]="peopleData"></grid-people>
</div>
